import {
    Pagination,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableFooter,
    TableHeader,
    WindmillContext,
    TableRow
} from "@windmill/react-ui";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import SellerDoughnutChart from "components/chart/Pie/SellerPiechart";
import SellerProgress from "components/chart/Progress/SellerProgress"
import ChartCardone from "components/chart/ChartCardone";

import SalesCardItemOne from "components/dashboard/SalesCarditem-one";
import SalesCardItemtwo from "components/dashboard/salesCardItemtwo";

import TableLoading from "components/preloader/TableLoading";
import NotFound from "components/table/NotFound";
import PageTitle from "components/Typography/PageTitle";

import { SidebarContext } from "context/SidebarContext";
import useAsync from "hooks/useAsync";
import useFilter from "hooks/useFilter";
import sidebar from "routes/sidebar";
import "../dashboardComponents/Accountsalesdashboard.css"


import DashboardServices from "services/DashboardServices";

import totalsaleamountimg
    from "../../assets/sellerdashboardicons/totalsaleamountimg.webp";

import todaybookingimg
    from "../../assets/sellerdashboardicons/todaybookingimg.webp";

import yesterdaybookingImg
    from "../../assets/sellerdashboardicons/yesterdaybookingImg.webp";

import thismonthbookingimg
    from "../../assets/sellerdashboardicons/thismonthbookingimg.webp";

import TotalBookingImg
    from "../../assets/sellerdashboardicons/totalbookingimg.webp";
import CancellationImg
    from "../../assets/sellerdashboardicons/cancellationimg.webp";
import TodayArrivals
    from "../../assets/sellerdashboardicons/todayarrivalsimg.webp";
import UnAssigneddriversImg
    from "../../assets/sellerdashboardicons/assigneddriverImg.webp";

const SellerSalesDashboard = () => {
    const { globalSetting } = useFilter();
    const { mode } = useContext(WindmillContext);
    const { currentPage, handleChangePage, lang } =
        useContext(SidebarContext);
    const { t } = useTranslation();

    const currency = globalSetting?.default_currency || "₹";

    const adminInfo = localStorage.getItem("adminInfo")
        ? JSON.parse(localStorage.getItem("adminInfo"))
        : null;
    const employeeId = adminInfo?.id
    const {
        data: SellerData,
        loading: loadingSellerData,
        error,
    } = useAsync(() => DashboardServices.getProfileDashboard(employeeId));
    useEffect(() => {
        // console.log("Loading:", loadingSellerData);
        // console.log("Data:", SellerData);
    }, [loadingSellerData, SellerData]);



    const formatDateDMY = (iso) => {
        if (!iso) return "-";
        return new Date(iso).toLocaleDateString("en-GB", {
            timeZone: "UTC",
        });
    };
    return (
        <>
            <PageTitle sidebar={sidebar().sidebar} />
            <h1
                style={{
                    color: "black",
                    fontWeight: 600,
                    fontSize: "20px",
                }}
            >
                Current Month Status
            </h1>

            <div className="grid gap-4 mb-8 md:grid-cols-4">

                <SalesCardItemtwo
                    mode={mode}
                    currency={currency}
                    title2="Total Sale Amounts"
                    Img={totalsaleamountimg}
                    price={SellerData?.data?.stats?.data?.total_sale_amount ?? 0}
                    className="bg-white text-black"
                    loading={loadingSellerData}
                    // onNavigation='/bookings'
                    
                />
                <SalesCardItemtwo
                    mode={mode}
                    currency={currency}
                    title2="Today Booking Values"
                    Img={todaybookingimg}
                    price={SellerData?.data?.stats?.data?.today_sale_amount ?? 0}
                    className="bg-white text-black"
                    loading={loadingSellerData}
                    onNavigation='/bookings'
                    passDates={true}
                />
                <SalesCardItemtwo
                    mode={mode}
                    currency={currency}
                    title2="Yesterday Booking Values"
                    Img={yesterdaybookingImg}
                    price={SellerData?.data?.stats?.data?.yesterday_sale_amount ?? 0}
                    className="bg-white text-black"
                    loading={loadingSellerData}
                    onNavigation='/bookings'
                    yesterddaydate={true}
                />
                <SalesCardItemtwo
                    mode={mode}
                    currency={currency}
                    title2="This month Booking values"
                    Img={thismonthbookingimg}
                    price={SellerData?.data?.stats?.data?.current_month_sale_amount ?? 0}
                    className="bg-white text-black"
                    loading={loadingSellerData}
                    onNavigation='/bookings'
                    current_month={true}
                />
            </div>



            <div className="grid gap-4 md:grid-cols-4 ">
                <SalesCardItemOne
                    card_bg_color='#D7FFDE'
                    title="Total Bookings"
                    Img={TotalBookingImg}
                    quantity={Number(SellerData?.data?.stats?.data?.current_bookings_count) || 0}
                    onNavigation='/bookings'
                    current_month={true}
                />
                <SalesCardItemOne
                    card_bg_color='#FFF3D7'
                    title="Cancellations"
                    Img={CancellationImg}
                    quantity={Number(SellerData?.data?.stats?.data?.cancelled_bookings_count) || 0}
                    onNavigation='/bookings'
                    current_month={true}
                    type={8}
                />
                <SalesCardItemOne
                    card_bg_color='#D7DBFF'
                    title="Today Arrivals"
                    Img={TodayArrivals}
                    quantity={Number(SellerData?.data?.stats?.data?.today_arrivals_count) || 0}
                    onNavigation='/bookings'
                    passDates={true}
                />
                <SalesCardItemOne
                    card_bg_color='#FED7FF'
                    title="Unalloted Vehicles"
                    Img={UnAssigneddriversImg}
                    quantity={Number(SellerData?.data?.stats?.data?.unalloted_vehicle_count) || 0}
                    // onNavigation='/vehicle-allotment'
                    // todatonext30days={true}
                   daytitle="+30 Days"
                />
            </div>

            <div className="flex flex-wrap justify-between my-8 w-full">
                <ChartCardone
                    cardsize='60'
                    mode={mode}
                    loading={loadingSellerData}
                    title={t("")}
                >
                    <SellerDoughnutChart salesReport={SellerData} />
                </ChartCardone>

                <ChartCardone
                    cardsize='38'
                    mode={mode}
                    loading={loadingSellerData}
                    title={t("")}
                >
                    <SellerProgress salesReport={SellerData} />
                </ChartCardone>
            </div>

            <h1 className=" font-bold mb-3 mt-1" style={{ fontSize: "24px" }}>
                Recent Orders
            </h1>
            {loadingSellerData ? (
                <TableLoading row={5} col={7} />
            ) : SellerData?.data?.recent_bookings?.length > 0 ? (
                <TableContainer>
                    <Table>
                        <TableHeader className="text-center">
                            <tr  className="text-sm">
                                <TableCell >SI.NO</TableCell>
                                <TableCell>Agent Ref No</TableCell>
                                <TableCell >Client Name</TableCell>
                                <TableCell>Travel Date</TableCell>
                                <TableCell>Service Type</TableCell>
                                <TableCell>Booking Date</TableCell>

                            </tr>
                        </TableHeader>

                        <TableBody>
                            {SellerData?.data?.recent_bookings?.map((row, index) => (


                                <TableRow key={index} className="text-center">
                                    <TableCell>{index + 1}</TableCell>
                                    <TableCell >
                                        <div className="pt-2 text-blue-400">
                                            <span className="text-sm">{row.agent_ref_no || '-'}</span>
                                        </div>
                                    </TableCell>
                                    <TableCell>{row.client_name || '-'}</TableCell>

                                    <TableCell className="text-center">
                                        {row.start_date && row.end_date ? (
                                            <>
                                                <div>{formatDateDMY(row.start_date || '-')}</div>
                                                <div className="pt-3">{formatDateDMY(row.end_date || '-')}</div>
                                            </>
                                        ) : (
                                            "-"
                                        )}
                                    </TableCell>

                                    <TableCell>{row.package_type || '-'}</TableCell>
                                    <TableCell>{formatDateDMY(row.booking_date || '-')}</TableCell>

                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            ) : (
                <NotFound title="No recent bookings found" />
            )}

        </>
    );
};

export default SellerSalesDashboard;